export default __webpack_public_path__ + "static/media/522972a6-5867-47ae-82fc-a7cf9bd5d4d4.561c8a31.eot";